module.exports = __webpack_public_path__ + "img/coupon_blue.png?v=5d60d6da";